import type { AppMode } from 'src/App/context/PricingContextProvider';

import { PricingModel } from '../Product';
import { ContractType, type AdvertiserContract } from 'src/hooks';

export const getContractType = (advertiserContracts: AdvertiserContract[]) => {
  const isVariablePriceContract = (contract: AdvertiserContract) =>
    contract.contractType === ContractType.SEEK_CONTRACT;
  const isFixedPriceContract = (contract: AdvertiserContract) =>
    contract.contractType === ContractType.AD_PACK ||
    contract.contractType === ContractType.MASTER_AGREEMENT ||
    contract.contractType === ContractType.SUBSCRIPTION;
  if (advertiserContracts.some(isVariablePriceContract)) {
    return 'contract';
  } else if (advertiserContracts.some(isFixedPriceContract)) {
    return 'ad-pack';
  }
  return 'casual';
};

export const getPricingType = (pricingModel: PricingModel) =>
  pricingModel === PricingModel.HORIZON ? 'variable' : 'fixed';

export const getCurrentPage = (appMode: AppMode) => {
  switch (appMode) {
    case 'PREVIEW':
      return 'ad price lookup preview';
    default:
      return 'ad price lookup full';
  }
};

export const getEventName = (appMode: AppMode) => {
  switch (appMode) {
    case 'PREVIEW':
      return 'ad_price_lookup_preview_displayed';
    default:
      return 'ad_price_lookup_full_displayed';
  }
};
